export default "__VITE_ASSET__CYYQ_pDm__"